import { render, staticRenderFns } from "./BrandLogosWidget.vue?vue&type=template&id=1e57235a"
import script from "./BrandLogosWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrandLogosWidget.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports